import {get} from '@yandex-delivery/utils'

import type {
  MapVerticalRequirements,
  RequirementsMap,
  TariffVertical,
  VerticalAlwaysBooleanRequirement,
  VerticalBooleanRequirement,
  VerticalBoolTariffRequirement,
  VerticalIncludedTariffRequirement,
  VerticalMultiSelectRequirement,
  VerticalSelectRequirement,
  VerticalSelectTariffRequirement,
  VerticalTariffRequirement,
} from 'src/shared/types'

const toBoolTariffRequirement = (
  requirement: VerticalBoolTariffRequirement,
  defaultValue = false,
): VerticalBooleanRequirement => ({
  ...requirement,
  type: 'bool',
  selectedValue: requirement.default_value || defaultValue,
})

const toSelectTariffRequirement = (requirement: VerticalSelectTariffRequirement): VerticalSelectRequirement => ({
  ...requirement,
  type: 'select',
  selectedValue: requirement.options[0]?.value,
})

const toMultiSelectTariffRequirement = (
  requirement: VerticalSelectTariffRequirement,
): VerticalMultiSelectRequirement => ({
  ...requirement,
  type: 'multi_select',
  selectedValue: [],
})

const toAlwaysBooleanTariffRequirement = (
  requirement: VerticalIncludedTariffRequirement,
): VerticalAlwaysBooleanRequirement => ({
  ...requirement,
  type: 'included',
  selectedValue: true,
})
function toCargoLoadersRequirement(
  loadersRequirement: VerticalSelectTariffRequirement,
  requirements?: VerticalTariffRequirement[],
): VerticalSelectRequirement {
  // дефолтное количество грузчиков для дефолтного размера кузова
  function getCargoLoaders(tariffRequirements?: VerticalTariffRequirement[]): number | undefined {
    const requirement = tariffRequirements?.find(requirementItem => requirementItem.name === 'cargo_type')

    if (requirement && 'options' in requirement) {
      const settings = get('options.0.restrictions.loaders_settings', requirement)
      return settings?.find(setting => setting.is_delivery_enabled)?.loaders_count || 0
    }
  }

  return {
    ...loadersRequirement,
    type: 'select',
    selectedValue: getCargoLoaders(requirements),
  }
}

export function mapVerticalRequirements(verticals: TariffVertical[]): MapVerticalRequirements {
  return verticals.reduce<MapVerticalRequirements>((acc, vertical) => {
    const requirements = vertical.requirements?.reduce<RequirementsMap>((map, requirement) => {
      switch (requirement.type) {
        case 'bool':
          map[requirement.name] = toBoolTariffRequirement(requirement)
          break
        case 'included':
          map[requirement.name] = toAlwaysBooleanTariffRequirement(requirement)
          break
        case 'select':
          map[requirement.name] =
            requirement.name === 'cargo_loaders'
              ? toCargoLoadersRequirement(requirement, vertical.requirements)
              : toSelectTariffRequirement(requirement)
          break
        case 'multi_select':
          map[requirement.name] = toMultiSelectTariffRequirement(requirement)
          break
      }

      return map
    }, {})

    acc[vertical.id] = {
      name: get('id', vertical),
      dueSettings: get('dueSettings', vertical),
      deliveryIntervals: get('deliveryIntervals', vertical),
      requirements,
    }

    return acc
  }, {})
}
